import type { SelectValue } from '@shared/ui/select';
import {
  INVITATION_TYPE_BOTH,
  INVITATION_TYPE_EMAIL,
  INVITATION_TYPE_SMS,
  INVITATION_TYPE_VK_TEAMS,
  type InvitationTypeValue,
} from './invitation-types';

export const CHANNEL_LABEL_VK_TEAMS = 'VK Teams';
export const CHANNEL_LABEL_EMAIL = 'E-mail';
export const CHANNEL_LABEL_OUTLOOK = 'Outlook';
export const CHANNEL_LABEL_SMS = 'СМС';

export interface PreviewChannelItem {
  label: string;
  count: number;
  smsCostLabel?: string | null;
}

interface PreviewChannelsParams {
  typeValue: InvitationTypeValue | null;
  emailCount: number;
  smsCount: number;
  includeOutlook?: boolean;
}

export const previewChannels = ({
  typeValue,
  emailCount,
  smsCount,
  includeOutlook = false,
}: PreviewChannelsParams): PreviewChannelItem[] => {
  if (!typeValue) return [];

  const channels: PreviewChannelItem[] = [];
  const isSms = typeValue === INVITATION_TYPE_SMS || typeValue === INVITATION_TYPE_BOTH;
  const isEmail = typeValue === INVITATION_TYPE_EMAIL || typeValue === INVITATION_TYPE_BOTH;

  if (isEmail) {
    channels.push({ label: CHANNEL_LABEL_EMAIL, count: emailCount });
  }
  if (includeOutlook) {
    channels.push({ label: CHANNEL_LABEL_OUTLOOK, count: emailCount });
  }
  if (isSms) {
    channels.push({ label: CHANNEL_LABEL_SMS, count: smsCount });
  }

  return channels;
};

interface PreviewInvitationChannelsParams {
  selectedChannels: SelectValue[];
  emailCount: number;
  smsCount: number;
  vkCount: number;
  includeOutlook?: boolean;
}

export const previewInvitationChannels = ({
  selectedChannels,
  emailCount,
  smsCount,
  vkCount,
  includeOutlook = false,
}: PreviewInvitationChannelsParams): PreviewChannelItem[] => {
  const channels: PreviewChannelItem[] = [];

  if (selectedChannels.includes(INVITATION_TYPE_VK_TEAMS)) {
    channels.push({ label: CHANNEL_LABEL_VK_TEAMS, count: vkCount });
  }
  if (selectedChannels.includes(INVITATION_TYPE_EMAIL)) {
    channels.push({ label: CHANNEL_LABEL_EMAIL, count: emailCount });
  }
  if (includeOutlook) {
    channels.push({ label: CHANNEL_LABEL_OUTLOOK, count: emailCount });
  }
  if (selectedChannels.includes(INVITATION_TYPE_SMS)) {
    channels.push({ label: CHANNEL_LABEL_SMS, count: smsCount });
  }

  return channels;
};

export const attachSmsCostToSmsRow = (
  channels: PreviewChannelItem[],
  smsCostLabel: string | null
): PreviewChannelItem[] => {
  if (!smsCostLabel) return channels;
  return channels.map((ch) => (ch.label === CHANNEL_LABEL_SMS ? { ...ch, smsCostLabel } : ch));
};

interface PreviewTicketChannelsParams {
  selectedChannels: SelectValue[];
  emailCount: number;
  smsCount: number;
  vkCount: number;
}

export const previewTicketChannels = ({
  selectedChannels,
  emailCount,
  smsCount,
  vkCount,
}: PreviewTicketChannelsParams): PreviewChannelItem[] => {
  if (!selectedChannels.length) return [];

  const channels: PreviewChannelItem[] = [];

  if (selectedChannels.includes(INVITATION_TYPE_VK_TEAMS)) {
    channels.push({ label: CHANNEL_LABEL_VK_TEAMS, count: vkCount });
  }
  if (selectedChannels.includes(INVITATION_TYPE_EMAIL)) {
    channels.push({ label: CHANNEL_LABEL_EMAIL, count: emailCount });
  }
  if (selectedChannels.includes(INVITATION_TYPE_SMS)) {
    channels.push({ label: CHANNEL_LABEL_SMS, count: smsCount });
  }

  return channels;
};
